module.exports = __webpack_public_path__ + "media/images/partners/isaac_square-fed2e7f0b003852f40823780dd0a0496.svg";